import React, { useContext } from "react";
import { Badge, Dropdown, Icon, Menu, Modal } from "antd";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { ContainerContext } from "App";
import Style from "./header.module.scss";
import logo from "./img/logo.png";
import useDeviceType from "Utils/useDeviceType";
import HeaderMobile from "./components/HeaderMobile";
import { useAtomValue } from "jotai";
import { loginUnifySetAtom } from "Stores/SettingsStore";
import useStorage from "Utils/useStorage";
import { LoginType, logout } from "API/auth";
import { studentEvaluationStatusAtom } from "pages/main/store";
import { isTrue } from "Utils/filter";
import { useMount } from "react-use";
import { AllCountAtom } from "Stores/CommonStore";
import { useUpdateNoticeCount } from "Utils/useUpdateNoticeCount";

const Header = () => {
    const isEvaluation = useAtomValue(studentEvaluationStatusAtom);

    const history = useHistory();
    const { isWebview } = useDeviceType();

    const loginUnifySet = useAtomValue(loginUnifySetAtom);
    const [loginType] = useStorage("LoginType");

    const { isInside } = useContext(ContainerContext);

    let num = useAtomValue(AllCountAtom);
    const match = useRouteMatch();

    const updateCount = useUpdateNoticeCount();
    useMount(updateCount);

    function isMath(path: string) {
        if (path === "/") return match.path === "/";
        return match.path.indexOf(path) === 0;
    }

    function onLogout() {
        Modal.confirm({
            title: "提示",
            content: "确定要退出登录吗?",
            onOk: logout
        });
    }

    function changePwd() {
        if (loginType === LoginType.CAS) {
            if (!isWebview) {
                window.location.href = loginUnifySet.changePasswordUrl;
            } else {
                window.ReactNativeWebView?.call(
                    "changePassword",
                    loginUnifySet.changePasswordUrl
                );
            }
        } else {
            history.push("/changepwd");
        }
    }

    const { isPC } = useDeviceType();

    if (isInside) {
        return null;
    }

    const menu = (
        <Menu className={Style.Menu}>
            {isWebview && (
                <Menu.Item>
                    <button
                        type="button"
                        className={Style.MenuItem}
                        onClick={() => history.push("/settings")}>
                        <Icon type="setting" /> 系统设置
                    </button>
                </Menu.Item>
            )}

            <Menu.Item>
                <button
                    type="button"
                    onClick={changePwd}
                    className={Style.MenuItem}>
                    <Icon type="security-scan" /> 修改密码
                </button>
            </Menu.Item>

            <Menu.Item>
                <button
                    type="button"
                    onClick={onLogout}
                    className={Style.MenuItem}>
                    <Icon type="poweroff" /> 退出登录
                </button>
            </Menu.Item>
        </Menu>
    );

    if (!isPC) return <HeaderMobile menu={menu} />;

    return (
        <div className={Style.header}>
            <div className={Style.wrap}>
                <div className={Style.logo}>
                    <Link to={"/"}>
                        <img
                            src={logo}
                            alt="Dufe"
                            style={{ marginTop: "0px" }}
                        />
                        <span className={Style.logoText}>&nbsp;白果云课堂</span>
                    </Link>
                </div>

                <div className={Style.Navigation}>
                    <ul className={Style.menuList}>
                        <li
                            className={`${Style.item} ${
                                isMath("/") ? Style.current : ""
                            }`}>
                            <Link to="/">课程表</Link>
                        </li>
                        <li
                            className={`${Style.item} ${
                                isMath("/evaluate/list") ? Style.current : ""
                            }`}>
                            <Badge dot={isTrue(isEvaluation)}>
                                <Link to="/evaluate/list">我的</Link>
                            </Badge>
                        </li>
                        <li
                            className={`${Style.item} ${
                                isMath("/homework") ? Style.current : ""
                            }`}>
                            <Link to="/homework">作业</Link>
                        </li>
                        <li
                            className={`${Style.item} ${
                                isMath("/exam") ? Style.current : ""
                            }`}>
                            <Link to="/exam">考试</Link>
                        </li>
                        <li
                            className={`${Style.item} ${
                                isMath("/experiment") ? Style.current : ""
                            }`}>
                            <Link to="/experiment">实验</Link>
                        </li>
                        <li
                            className={`${Style.item} ${
                                isMath("/askTeacher") ? Style.current : ""
                            }`}>
                            <Link to="/askTeacher">答疑</Link>
                        </li>
                        <li
                            className={`${Style.item} ${
                                isMath("/chat") ? Style.current : ""
                            }`}>
                            <Link to="/chat">私信</Link>
                        </li>
                        <li
                            className={`${Style.item} ${
                                isMath("/notice") ? Style.current : ""
                            }`}>
                            <Link to="/notice" style={{ position: "relative" }}>
                                消息中心
                                <div
                                    className={Style.badge}
                                    style={{
                                        display: num > 0 ? "block" : "none"
                                    }}>
                                    <p>{num > 99 ? "99+" : num}</p>
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className={Style.toolbar}>
                    <Dropdown overlay={menu} trigger={["click", "hover"]}>
                        <div className={Style.Dropdown}>
                            {/*{userName.substr(0,6)} */}
                            {localStorage.getItem("user")}{" "}
                            <Icon type="down" style={{ marginLeft: "10px" }} />
                        </div>
                    </Dropdown>
                </div>

                <div className={Style.bell}>
                    <Link to={"/notice"} style={{ position: "relative" }}>
                        <Icon
                            type="bell"
                            style={{ fontSize: "14px", color: "#fff" }}
                        />
                        <div
                            className={Style.badge}
                            style={{ display: num > 0 ? "block" : "none" }}>
                            <p
                                style={{
                                    marginLeft: num > 99 ? "1px" : "-1px"
                                }}>
                                {num > 99 ? "99+" : num}
                            </p>
                        </div>
                    </Link>
                </div>

                <ul className={Style.navigation}>
                    <li>
                        <a href="/feedback" target="_blank">
                            问题反馈
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.edufe.com.cn/bgyhelp/stu/"
                            target="_blank">
                            帮助中心
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Header;
